import React from 'react';
import { Navigate, useParams } from 'react-router-dom-latest';

const AccountBillingRedirect = ({ contact = false }) => {
  const { id } = useParams();
  const basePath = contact ? 'contactdetails' : 'accountdetails';

  return <Navigate to={`/${basePath}/${id}`} replace />;
};

export default AccountBillingRedirect;
